/* eslint-disable no-console */
/* istanbul ignore file */
/**
 * Print messages to console in development
 */
export const debugInfo = (message?: any, ...optionalParams: any[]) => {
    if (process.env.NODE_ENV === 'development') {
        console.warn(message, ...optionalParams);
    }
};
